<template>
  <div>
    <v-tooltip left color="red darken-2">
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          small
          dark
          fixed
          top
          right
          class="setting-fab"
          color="red darken-2"
          @click="openDrawer"
          v-on="on"
          elevation-4
        >
          <v-icon medium color="white">{{ icon }}</v-icon>
        </v-btn>
      </template>
      <span class="white--text font-weight-bold body-2 text-uppercase"
        >See {{ title }}</span
      >
    </v-tooltip>

    <v-navigation-drawer
      class="config-drawer"
      temporary
      right
      v-model="drawer"
      fixed
    >
      <v-toolbar color="blue" dark top style="margin-top:-10px;">
        <v-toolbar-title>
          <v-layout>
            <v-flex m8>
              <h5 class="heading text-uppercase font-weight-medium pt-3">
                {{ title }}
              </h5>
            </v-flex>
            <v-flex md4 class="justify-end align-end text-right">
              <v-btn
                flat
                small
                @click.stop="drawer = !drawer"
                class="justify-end align-end text-right"
              >
                <v-icon
                  class="justify-end align-end text-right"
                  color="grey lighten-1"
                  >close</v-icon
                >
              </v-btn>
            </v-flex>
          </v-layout>
        </v-toolbar-title>
      </v-toolbar>
      <ul type="none" class="mt-2">
        <li
          v-for="item in items"
          :key="item.name"
          @click="sheet = false"
          class="text-left py-1"
        >
          <v-icon small color="red ">label_important</v-icon>
          {{ item.name }} : <strong>{{ item.value }}</strong> {{ item.unit }}
        </li>
      </ul>
    </v-navigation-drawer>
  </div>
</template>
<script>
export default {
  props: {
    items: Array,
    title: String,
    icon: String,
    side: String
  },
  data() {
    return {
      drawer: null
    }
  },
  methods: {
    openDrawer() {
      this.$vuetify.goTo(0)
      this.drawer = !this.drawer
    }
  }
}
</script>

<style lang="scss" scoped>
.config-drawer {
  top: 40px; /*header*/
  padding-top: 10px;
  background: whitesmoke !important;
  z-index: 98 !important;
}
.setting-fab {
  top: 17% !important;
  right: 0;
  // border-top-right-radius: 4px;
  // border-bottom-right-radius: 4px;
  // -webkit-border-top-right-radius: 4px;
  // -webkit-border-bottom-right-radius: 4px;
  // -moz-border-radius-topright: 4px;
  // -moz-border-radius-bottomright: 4px;
}
</style>
